/* ============================================
   DIVINED RACING — THEME JS
   ============================================ */

(function() {
  'use strict';

  /* --- CART API --- */
  const Cart = {
    async get() {
      const res = await fetch(window.routes.cart_url + '.js');
      return res.json();
    },

    async add(id, quantity = 1, properties = {}) {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id), quantity, properties }] })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add item to cart');
      }
      return res.json();
    },

    async change(key, quantity) {
      const res = await fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      return res.json();
    },

    async update(updates) {
      const res = await fetch(window.routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      return res.json();
    }
  };

  /* --- CART DRAWER --- */
  const cartDrawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('overlay');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Close on overlay click
  if (overlay) overlay.addEventListener('click', closeCartDrawer);

  // Close button
  document.addEventListener('click', function(e) {
    if (e.target.closest('.cart-drawer__close')) {
      e.preventDefault();
      closeCartDrawer();
    }
  });

  // Cart icon opens drawer
  document.addEventListener('click', function(e) {
    const cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      e.preventDefault();
      openCartDrawer();
      renderCartDrawer();
    }
  });

  // Render the cart drawer contents
  async function renderCartDrawer() {
    const cart = await Cart.get();
    const itemsEl = document.querySelector('.cart-drawer__items');
    const footerEl = document.querySelector('.cart-drawer__footer');
    const countEls = document.querySelectorAll('[data-cart-count]');
    const freeShipThreshold = 5000; // $50 in cents

    // Update cart count badges
    countEls.forEach(el => {
      el.textContent = cart.item_count > 0 ? cart.item_count : '';
    });

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--outline btn--small">Continue Shopping</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';

    let html = '';
    cart.items.forEach(function(item) {
      const img = item.image ? item.image.replace(/(\.[^.]+)$/, '_180x$1') : '';
      html += '<div class="cart-item" data-key="' + item.key + '">';
      html += '  <div class="cart-item__image"><a href="' + item.url + '"><img src="' + img + '" alt="' + item.title + '" loading="lazy"></a></div>';
      html += '  <div class="cart-item__info">';
      html += '    <div class="cart-item__title">' + item.product_title + '</div>';
      if (item.variant_title) {
        html += '    <div class="cart-item__variant">' + item.variant_title + '</div>';
      }
      if (item.properties) {
        Object.keys(item.properties).forEach(function(prop) {
          var val = item.properties[prop];
          if (val && prop.charAt(0) !== '_') {
            html += '    <div class="cart-item__props">' + prop + ': ' + String(val).replace(/</g, '&lt;') + '</div>';
          }
        });
      }
      html += '    <div class="cart-item__bottom">';
      html += '      <div class="cart-item__qty">';
      html += '        <button data-qty-change="-1" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>';
      html += '        <span>' + item.quantity + '</span>';
      html += '        <button data-qty-change="1" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>';
      html += '      </div>';
      html += '      <div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>';
      html += '    </div>';
      html += '    <button class="cart-item__remove" data-remove-key="' + item.key + '">Remove</button>';
      html += '  </div>';
      html += '</div>';
    });

    itemsEl.innerHTML = html;

    // Footer
    if (footerEl) {
      const progress = Math.min((cart.total_price / freeShipThreshold) * 100, 100);
      const remaining = freeShipThreshold - cart.total_price;
      let shippingHtml = '';

      shippingHtml = '';

      footerEl.innerHTML = shippingHtml +
        '<div class="cart-drawer__subtotal">' +
        '  <span class="cart-drawer__subtotal-label">Subtotal</span>' +
        '  <span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<a href="/checkout" class="btn btn--primary btn--full">Checkout</a>';
    }
  }

  // Quantity change in drawer
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const key = btn.dataset.key;
    const change = parseInt(btn.dataset.qtyChange);
    const currentQty = parseInt(btn.parentElement.querySelector('span').textContent);
    const newQty = Math.max(0, currentQty + change);
    await Cart.change(key, newQty);
    renderCartDrawer();
  });

  // Remove from drawer
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-remove-key]');
    if (!btn) return;
    await Cart.change(btn.dataset.removeKey, 0);
    renderCartDrawer();
  });

  /* --- ADD TO CART (works on product pages AND quick-add buttons) --- */
  document.addEventListener('submit', async function(e) {
    const form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[data-add-btn]');
    if (btn) {
      btn.classList.add('btn--loading');
      btn.disabled = true;
    }

    try {
      const formData = new FormData(form);
      const id = formData.get('id');
      const qty = parseInt(formData.get('quantity') || 1);

      // Collect line item properties (e.g. properties[Jersey Number])
      const properties = {};
      for (const [key, value] of formData.entries()) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim() !== '') {
          properties[match[1]] = String(value).trim();
        }
      }

      await Cart.add(id, qty, properties);
      openCartDrawer();
      await renderCartDrawer();
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) {
        btn.classList.remove('btn--loading');
        btn.disabled = false;
      }
    }
  });

  // Quick-add button (single click, no form)
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();

    btn.classList.add('btn--loading');
    btn.disabled = true;

    try {
      await Cart.add(btn.dataset.quickAdd, 1);
      openCartDrawer();
      await renderCartDrawer();
    } catch (err) {
      alert(err.message);
    } finally {
      btn.classList.remove('btn--loading');
      btn.disabled = false;
    }
  });

  /* --- MOBILE MENU --- */
  document.addEventListener('click', function(e) {
    const toggle = e.target.closest('.menu-toggle');
    if (!toggle) return;
    toggle.classList.toggle('active');
    const nav = document.querySelector('.site-header__nav');
    if (nav) nav.classList.toggle('open');
  });

  /* --- COUNTDOWN TIMER --- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function(el) {
      var target = new Date(el.dataset.countdown).getTime();

      function tick() {
        var now = Date.now();
        var diff = target - now;

        if (diff <= 0) {
          el.innerHTML = '<span class="countdown__expired">LIVE NOW</span>';
          return;
        }

        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);

        var units = el.querySelectorAll('.countdown__number');
        if (units.length === 4) {
          units[0].textContent = String(days).padStart(2, '0');
          units[1].textContent = String(hours).padStart(2, '0');
          units[2].textContent = String(mins).padStart(2, '0');
          units[3].textContent = String(secs).padStart(2, '0');
        }

        requestAnimationFrame(function() {
          setTimeout(tick, 1000);
        });
      }

      tick();
    });
  }

  /* --- VARIANT SELECTOR (product page) --- */
  function initVariantSelector() {
    document.querySelectorAll('.variant-option').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = this.closest('.variant-group');
        var optionIndex = parseInt(group.dataset.optionIndex || 0);

        // Update selection state
        group.querySelectorAll('.variant-option').forEach(function(b) { b.classList.remove('selected'); });
        this.classList.add('selected');

        // Update the "— Selected" label
        var labelEl = group.querySelector('.variant-group__selected');
        if (labelEl) labelEl.textContent = '— ' + this.dataset.value;

        // Collect all selected options
        var productForm = this.closest('[data-add-to-cart-form]') || document.querySelector('[data-add-to-cart-form]');
        if (!productForm) return;

        var selectedOptions = [];
        document.querySelectorAll('.variant-group').forEach(function(g) {
          var sel = g.querySelector('.variant-option.selected');
          if (sel) selectedOptions.push(sel.dataset.value);
        });

        // Find matching variant from product JSON
        var productData = window.productData;
        if (!productData) return;

        var match = productData.variants.find(function(v) {
          return v.options.every(function(opt, i) {
            return opt === selectedOptions[i];
          });
        });

        if (match) {
          // Update hidden ID input
          var idInput = productForm.querySelector('input[name="id"]');
          if (idInput) idInput.value = match.id;

          // Update price display
          var priceEl = document.querySelector('.product-page__price .current-price');
          if (priceEl) priceEl.textContent = formatMoney(match.price);

          var compareEl = document.querySelector('.product-page__price .compare-price');
          if (compareEl) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              compareEl.textContent = formatMoney(match.compare_at_price);
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }

          // Update savings display
          var savingsEl = document.querySelector('.product-page__price .body-xs');
          if (savingsEl) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              savingsEl.textContent = 'Save ' + formatMoney(match.compare_at_price - match.price);
              savingsEl.style.display = '';
            } else {
              savingsEl.style.display = 'none';
            }
          }

          // Update button state and text
          var addBtn = productForm.querySelector('[data-add-btn]');
          if (addBtn) {
            if (match.available) {
              addBtn.disabled = false;
              addBtn.textContent = 'Add to Cart — ' + formatMoney(match.price);
            } else {
              addBtn.disabled = true;
              addBtn.textContent = 'Sold Out';
            }
          }

          // Update URL without reload
          if (window.history && window.history.replaceState) {
            var url = window.location.pathname + '?variant=' + match.id;
            window.history.replaceState({}, '', url);
          }

          // === IMAGE SWITCHING ===
          // If this variant has an associated image, scroll gallery to it
          if (match.featured_image && match.featured_image.id) {
            var targetImageId = match.featured_image.id;
            var gallery = document.getElementById('product-gallery');
            if (!gallery) return;

            // Remove active state from all gallery items
            gallery.querySelectorAll('.product-page__gallery-item').forEach(function(item) {
              item.classList.remove('active-variant');
            });

            // Find the gallery item with this image ID
            var targetItem = gallery.querySelector('[data-image-id="' + targetImageId + '"]');
            if (targetItem) {
              targetItem.classList.add('active-variant');

              // Scroll gallery to show this image
              targetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }

          // Mark unavailable combinations
          markUnavailableOptions(productData, selectedOptions);
        }
      });
    });
  }

  // Grey out option combos that don't exist or are sold out
  function markUnavailableOptions(productData, selectedOptions) {
    document.querySelectorAll('.variant-group').forEach(function(group, groupIndex) {
      group.querySelectorAll('.variant-option').forEach(function(btn) {
        var testOptions = selectedOptions.slice();
        testOptions[groupIndex] = btn.dataset.value;

        var exists = productData.variants.some(function(v) {
          return v.options[groupIndex] === btn.dataset.value && v.available;
        });

        if (exists) {
          btn.classList.remove('unavailable');
        } else {
          // Check if ANY variant with this value exists (even sold out)
          var anyExists = productData.variants.some(function(v) {
            return v.options[groupIndex] === btn.dataset.value;
          });
          if (!anyExists) {
            btn.classList.add('unavailable');
          } else {
            btn.classList.remove('unavailable');
          }
        }
      });
    });
  }

  /* --- QUANTITY SELECTOR (product page) --- */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var current = parseInt(input.value) || 1;
    var change = parseInt(btn.dataset.qtyBtn);
    input.value = Math.max(1, current + change);
  });

  /* --- SCROLL ANIMATIONS --- */
  function initScrollAnimations() {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.fade-in').forEach(function(el) {
      observer.observe(el);
    });
  }

  /* --- MONEY FORMAT --- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* --- INIT --- */
  document.addEventListener('DOMContentLoaded', function() {
    initCountdowns();
    initVariantSelector();
    initScrollAnimations();
    renderCartDrawer();
  });

})();
